/* Roadmap: "Pick your route" filtering for the home finder and coffee collection */
(function () {
  var GROUPS = ['roast', 'cup', 'decaf'];

  function init(root) {
    if (root.__rmReady) return;
    root.__rmReady = true;

    var mode = root.getAttribute('data-mode') || 'collection';
    var limit = parseInt(root.getAttribute('data-limit') || '0', 10);
    var baseUrl = root.getAttribute('data-base-url') || '';
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-rm-chip]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rm-card]'));
    var countEl = root.querySelector('[data-rm-count]');
    var emptyEl = root.querySelector('[data-rm-empty]');
    var allLink = root.querySelector('[data-rm-all]');
    var resetBtns = Array.prototype.slice.call(root.querySelectorAll('[data-rm-reset]'));
    var resetBtn = root.querySelector('[data-rm-reset="toggle"]');
    var state = { roast: '', cup: '', decaf: '' };

    if (mode === 'collection') {
      var params = new URLSearchParams(window.location.search);
      GROUPS.forEach(function (g) { state[g] = params.get(g) || ''; });
    }

    // Order finder results: scored coffees first, then the collection's order.
    if (mode === 'finder') {
      cards.forEach(function (c, i) { c.__rmIndex = i; });
    }

    function matches(card) {
      if (state.roast && card.getAttribute('data-roast') !== state.roast) return false;
      if (state.cup && card.getAttribute('data-cup') !== state.cup) return false;
      if (state.decaf === '1' && card.getAttribute('data-decaf') !== '1') return false;
      return true;
    }

    function query() {
      var q = new URLSearchParams();
      GROUPS.forEach(function (g) { if (state[g]) q.set(g, state[g]); });
      var s = q.toString();
      return s ? '?' + s : '';
    }

    function render() {
      chips.forEach(function (chip) {
        var g = chip.getAttribute('data-group');
        var v = chip.getAttribute('data-value');
        chip.setAttribute('aria-pressed', state[g] === v ? 'true' : 'false');
      });

      var hits = cards.filter(matches);
      if (mode === 'finder') {
        hits.sort(function (a, b) {
          var sa = parseInt(a.getAttribute('data-score') || '0', 10);
          var sb = parseInt(b.getAttribute('data-score') || '0', 10);
          if (sb !== sa) return sb - sa;
          return a.__rmIndex - b.__rmIndex;
        });
        var grid = cards.length ? cards[0].parentNode : null;
        if (grid) hits.forEach(function (c) { grid.appendChild(c); });
      }

      var shown = limit > 0 ? hits.slice(0, limit) : hits;
      cards.forEach(function (c) { c.hidden = shown.indexOf(c) === -1; });

      if (countEl) {
        var n = hits.length;
        countEl.textContent = n + (n === 1 ? ' coffee' : ' coffees');
      }
      if (emptyEl) emptyEl.hidden = hits.length !== 0;
      if (allLink) allLink.setAttribute('href', baseUrl + query());
      if (resetBtn) resetBtn.hidden = !(state.roast || state.cup || state.decaf);

      if (mode === 'collection' && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + query());
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var g = chip.getAttribute('data-group');
        var v = chip.getAttribute('data-value');
        state[g] = state[g] === v ? '' : v;
        render();
      });
    });

    resetBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state = { roast: '', cup: '', decaf: '' };
        render();
      });
    });

    render();
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-rm-filter]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  // Re-run when sections reload in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  // Autoplay helper for background videos (some browsers need a nudge).
  function playAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.rm-hero video, .rm-band video, .rm-cafe video'), function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', playAll); else playAll();
})();
